<script setup lang="ts">
  import { useMatrixFillLabContext } from '../../model/useMatrixFillLab';
  import FieldRef from './FieldRef.vue';
  import FillActions from './FillActions.vue';
  import JsonBlock from './JsonBlock.vue';
  import LabSection from './LabSection.vue';
  import SavedResponsesList from './SavedResponsesList.vue';

  const lab = useMatrixFillLabContext();
</script>

<template>
  <LabSection
    title="Respostas"
    data-testid="lab-archive"
    :badge="`${lab.responses.value.length} salva(s)`"
    hint="O que a tela guardaria: um MatrixAnswers por resposta. Salvar exige zero erros de validação; arquivar exige, além disso, todo campo âncora preenchido (regra provisória)."
  >
    <FillActions />

    <div v-if="lab.anchorFields.value.length > 0">
      <p class="mb-1 font-semibold">
        Âncoras desta matriz
      </p>
      <ul class="flex flex-col gap-1">
        <li
          v-for="anchor in lab.anchorFields.value"
          :key="anchor.id"
          class="flex items-center gap-2 rounded-md bg-[var(--color-white-02)] px-2 py-1"
        >
          <FieldRef :id="anchor.id" />
          <span
            class="ml-auto shrink-0 rounded-full px-2 py-0.5 text-[10px] font-semibold"
            :class="
              anchor.hiddenByRule
                ? 'bg-[var(--color-gray-09)] text-[var(--color-gray-05)]'
                : anchor.filled
                  ? 'bg-green-100 text-green-800'
                  : 'bg-amber-100 text-amber-800'
            "
          >
            {{ anchor.hiddenByRule ? 'oculto por regra: não conta' : anchor.filled ? 'preenchido' : 'vazio' }}
          </span>
        </li>
      </ul>
    </div>

    <JsonBlock
      title="Respostas atuais (MatrixAnswers)"
      :value="lab.answers.value"
    />

    <SavedResponsesList />
  </LabSection>
</template>
